import { render } from "./Type2.vue?vue&type=template&id=b3dd5a38"
import script from "./Type2.vue?vue&type=script&lang=js"
export * from "./Type2.vue?vue&type=script&lang=js"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__